export const S3_ENDPOINT = 'http://s3wrapper.us-east-1.elasticbeanstalk.com/api'
export const S3_ENDPOINT_V2 =
  'https://67ilyyjlwa.execute-api.us-east-1.amazonaws.com/qa'
export const S3_QA_BUCKET = 'standalone-qa-pdf-files'
export const S3_PROD_BUCKET = 'standalone-prod-pdf-files'
export const S3_BUCKET = process.env.REACT_APP_S3_BUCKET
  ? S3_PROD_BUCKET
  : S3_QA_BUCKET

export const PRODUCTION_ENDPOINT = process.env.REACT_APP_ENDPOINT
  ? `${process.env.REACT_APP_ENDPOINT}/api`
  : undefined

// // export const QA_ENDPOINT = 'http://octavio.paredes-everest.nord:5000/api';
// export const QA_ENDPOINT = 'https://qa-api.cst-apps.com/api'
// // export const QA_PROXY_ENDPOINT = 'http://octavio.paredes-everest.nord:4000/api'
// export const QA_PROXY_ENDPOINT = 'https://proxy-qa.cst-apps.com/api'

export const QA_ENDPOINT = 'https://qa-api.cst-apps.com/api'
// export const QA_PROXY_ENDPOINT = 'http://localhost:4000/api'
export const QA_PROXY_ENDPOINT = 'https://proxy-qa.cst-apps.com/api'
// export const QA_ENDPOINT = 'http://127.0.0.1:5000/api';

export const BASE_URL_SYSTEM_PROPS_ENDPOINT = process.env.REACT_APP_SYSTEM_PROPS_ENDPOINT || 'https://qa-api.cst-apps.com'